// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3fNYi","actionsCol":"EnrolledClinics_actionsCol__unOax"};